/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `HaulRoute.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { HaulRoute } from "./HaulRoute";

import { CalendarEventResource } from "./CalendarEventResource";
import { MapObject } from "./MapObject";
import { Project } from "./Project";
import { WaypointDirection } from "./WaypointDirection";

export type attachmentMethod = "file" | "iframe";

export const attachmentMethodValues = { file: 0, iframe: 1 };

export abstract class HaulRouteModel {
    id: number;
    archived: boolean;
    attachmentMethod: attachmentMethod;
    bannedVehicles: string[] | null;
    createdAt: Dayjs;
    details: string | null;
    haulRouteIframe: string | null;
    name: string | null;
    projectId: number;
    updatedAt: Dayjs;
    repeatingCalendarEventDefinitions: any | null;
    calendarEventResources: CalendarEventResource[] | undefined;
    mapObject: MapObject | null | undefined;
    project: Project | null | undefined;
    waypointDirection: WaypointDirection | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        archived: boolean,
        attachmentMethod: attachmentMethod,
        bannedVehicles: string[] | null,
        createdAt: Dayjs,
        details: string | null,
        haulRouteIframe: string | null,
        name: string | null,
        projectId: number,
        updatedAt: Dayjs,
        repeatingCalendarEventDefinitions: any | null,
        calendarEventResources: CalendarEventResource[] | undefined,
        mapObject: MapObject | null | undefined,
        project: Project | null | undefined,
        waypointDirection: WaypointDirection | null | undefined
    ) {
        this.id = id;
        this.archived = archived;
        this.attachmentMethod = attachmentMethod;
        this.bannedVehicles = bannedVehicles;
        this.createdAt = createdAt;
        this.details = details;
        this.haulRouteIframe = haulRouteIframe;
        this.name = name;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.repeatingCalendarEventDefinitions = repeatingCalendarEventDefinitions;
        this.calendarEventResources = calendarEventResources;
        this.mapObject = mapObject;
        this.project = project;
        this.waypointDirection = waypointDirection;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): HaulRoute {
        const newObject = new HaulRoute(
            json["id"],
            json["archived"],
            json["attachment_method"],
            json["banned_vehicles"],
            dayjs(json["created_at"]).tz(timezone),
            json["details"],
            json["haul_route_iframe"],
            json["name"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["repeating_calendar_event_definitions"],
            json["calendar_event_resources"]?.map((item: any) => CalendarEventResource.fromApiObject(item, timezone)),
            json["map_object"] == null ? json["map_object"] : MapObject.fromApiObject(json["map_object"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["waypoint_direction"] == null
                ? json["waypoint_direction"]
                : WaypointDirection.fromApiObject(json["waypoint_direction"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            archived: this.archived,
            attachment_method: this.attachmentMethod,
            banned_vehicles: this.bannedVehicles,
            created_at: this.createdAt,
            details: this.details,
            haul_route_iframe: this.haulRouteIframe,
            name: this.name,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            calendar_event_resources_attributes: this.calendarEventResources
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            map_object_attributes: this.mapObject?.toApiObject(visited),
            project_attributes: this.project?.toApiObject(visited),
            waypoint_direction_attributes: this.waypointDirection?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): HaulRoute {
        const clone = Object.create(this) as HaulRoute;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
